import React from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import { Typography } from "@mui/material";

const Events = ({ todayEvents, weeklyEvents }) => {
  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <Tooltip title="Events">
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}>
          <NotificationsIcon
            sx={{ width: 32, height: 32 }}
            color={todayEvents.length ? "error" : ""}
          />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
        <Typography
          sx={{
            fontSize: "16px",
            paddingLeft: "15px",
            paddingRight: "15px",
            fontWeight: "bold",
          }}>
          Today
        </Typography>
        {todayEvents.length ? (
          todayEvents.map((event, key) => (
            <MenuItem sx={{ fontSize: "14px" }} key={key}>
              {event.title}
            </MenuItem>
          ))
        ) : (
          <MenuItem sx={{ fontSize: "14px" }}>No event</MenuItem>
        )}

        <Divider />

        <Typography
          sx={{
            fontSize: "16px",
            paddingLeft: "15px",
            paddingRight: "15px",
            fontWeight: "bold",
          }}>
          Coming Up
        </Typography>
        {weeklyEvents.length ? (
          weeklyEvents.map((event, key) => (
            <MenuItem sx={{ fontSize: "14px" }} key={key}>
              {event.title}, Days Left : {event.Diff}
            </MenuItem>
          ))
        ) : (
          <MenuItem sx={{ fontSize: "14px" }}>No event</MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default Events;
